<template>
  <el-checkbox class="mine-ob" style="margin-right: 20px;" v-model="currentVal">隐藏空文件夹</el-checkbox>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentVal:{
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.mine-ob {
  display: flex;
  align-items: center;

  .el-checkbox__input {
    line-height: 1px;

  }
  .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }
  .el-checkbox__label {
    line-height: 1;
    color: rgba(32, 32, 32, 0.6);
    font-size: 14px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    top: 6px;
    left: 0;
  }
}
</style>
